/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { UserDto } from '../models/UserDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {
  /**
   * 내 정보 조회
   * @returns UserDto
   * @throws ApiError
   */
  public static userControllerMe(): CancelablePromise<UserDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/me',
    });
  }

  /**
   * 내 정보 수정
   * @returns UserDto
   * @throws ApiError
   */
  public static userControllerUpdateUser({
    requestBody,
  }: {
    requestBody: UpdateUserDto;
  }): CancelablePromise<UserDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/users/me',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * 내 상세 정보 조회
   * @returns UserDto
   * @throws ApiError
   */
  public static userControllerDetailMe(): CancelablePromise<UserDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/me/detail',
    });
  }
}
